import clsx from "clsx"
import { useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"
import type { IEnergyPassportDetailsCell } from "@/features/energy-passport/ui/detail-tables/model/types.ts"
import { EnergyPassportElectricPowerHead } from "@/features/energy-passport/ui/electric-power-table/components/energy-passport-electric-power-head.tsx"
import { EnergyPassportElectricPowerQuarterRow } from "@/features/energy-passport/ui/electric-power-table/components/energy-passport-electric-power-quarter-row.tsx"

export const energyPassportElectricPowerCommonCells: IEnergyPassportDetailsCell[] = [
  "declared_consumption",
  "sub_consumption",
  "total_consumption",
  "technical_needs",
  "own_needs",
  "production_needs",
  "residential_needs",
  "consumption_standard",
  "max_nominal_capacity_per_hour"
]

const activeCells: IEnergyPassportDetailsCell[] = [
  {
    render: () => <span className="whitespace-nowrap">(P) актив</span>
  },
  ...energyPassportElectricPowerCommonCells
]

const reactiveCells: IEnergyPassportDetailsCell[] = [
  {
    render: () => <span className="whitespace-nowrap">(Q) реактив</span>
  },
  ...energyPassportElectricPowerCommonCells
]

export function EnergyPassportElectricPowerTable() {
  // Store
  const { active_electricity, reactive_electricity } = useEnergyPassportDetailsStore()

  return (
    <>
      <p className="my-3 text-sm">Энергетический баланс электроэнергии</p>
      <table className={clsx("base-table")}>
        <EnergyPassportElectricPowerHead />
        <tbody>
          <EnergyPassportElectricPowerQuarterRow cells={activeCells} storeItem={active_electricity} />
          <EnergyPassportElectricPowerQuarterRow cells={reactiveCells} storeItem={reactive_electricity} />
        </tbody>
      </table>
    </>
  )
}
